import { getFieldType } from './fieldTypeRegistry.jsx';

// Which two query params a composite control fills on the traditional list
// endpoint. Configurable because param names differ per module; the default
// covers the usual `<field>From` / `<field>To` pair.
export function rangeKeysFor(field) {
  if (Array.isArray(field.rangeKeys) && field.rangeKeys.length === 2) return field.rangeKeys;
  return [`${field.field}From`, `${field.field}To`];
}

// GET /module-data-list takes flat params, so a positional tuple ([from, to])
// has to be split. A multi-select's list of chips is left alone — that is one
// param the list endpoint already understands.
export function buildTraditionalParams(values = {}, fields = []) {
  const params = { ...values };

  fields.forEach((field) => {
    const type = field.type ?? 'text';

    // Sent via the generic `filters` mechanism instead (buildFilterConditions)
    // — its {preset,from,to} object has no flat-param representation, so it
    // must not reach the flatten-everything loop in searchModuleData.
    if (type === 'daterangePreset') {
      delete params[field.field];
      return;
    }

    if (!getFieldType(type).multiValue) return;
    if (type !== 'range' && type !== 'daterange') return;

    const raw = values[field.field];
    if (!Array.isArray(raw)) return;

    const [fromKey, toKey] = rangeKeysFor(field);
    delete params[field.field];

    const [from, to] = raw;
    if (from !== undefined && from !== null && from !== '') params[fromKey] = from;
    if (to !== undefined && to !== null && to !== '') params[toKey] = to;
  });

  return params;
}
